const Additional = () => {
  return (
    <section className="additional-info">
      <br />
      <strong>
        <label for="additional-1">Anything else you want to add?</label>
      </strong>
      <br />
      <br />
      <textarea
        className="additional-2"
        name="additional-2"
        rows="8"
        cols="40"
      ></textarea>
      <section className="submission">
        <input type="submit" value="Submit"></input>
      </section>
    </section>
  );
};

export default Additional;
